import { Box, Typography } from '@mui/material'

type UserItemMobileProps = {
  label: string
  content?: string
  icon?: JSX.Element
}

export default function UserItemMobile({ label, content, icon }: UserItemMobileProps) {
  return (
    <Box display="flex" py={'4px'} alignItems={'center'}>
      <Box
        p={'14px'}
        sx={theme => ({
          '& svg': {
            fill: theme.palette.grey[300]
          }
        })}
      >
        {icon}
      </Box>
      <Box>
        <Typography variant="caption" color="textSecondary" style={{ fontWeight: 500 }}>
          {label}
        </Typography>
        <Typography variant="body2" style={{ fontWeight: 400 }}>
          {content}
        </Typography>
      </Box>
    </Box>
  )
}
